import { DISPLAY_NAME, useContentContext } from '../../content'
import type { ContentScopedProps } from '../../content.types'
import { ContentIcon } from '../content-icon'
import {
  ContentContainerTitleVariants,
  ContentTitleVariants,
} from './content-titlte.styles'

type ContentTitleProps = {
  children: React.ReactNode
}

export function ContentTitle(props: ContentTitleProps) {
  const { children, __scopeContent } =
    props as ContentScopedProps<ContentTitleProps>

  const { variants, size } = useContentContext(DISPLAY_NAME, __scopeContent)

  return (
    <div
      className={ContentContainerTitleVariants({ variants })}
      data-testid="content-title"
    >
      <p className={ContentTitleVariants({ size })}>{children}</p>
      {variants === 'interactive' && (
        <ContentIcon
          symbol="rdicon-chevron-right"
          color="colorTextNeutralDefault"
          data-testid="content-icon-chevron"
        />
      )}
    </div>
  )
}
